<template>
  <div>
    <!-- <Collapse v-model="value" simple style="border: 0">
      <Panel name="1" hide-arrow style="margin: 20px 0; border: 0">
        <FormTitle titleText="个人信息" />
        <tabPane1Info slot="content" style="margin-top: 30px"></tabPane1Info>
      </Panel>
      <Panel
        hide-arrow
        style="margin: 20px 0; border: 0"
        v-for="(item, index) in panelList"
        :name="index + 2 + ''"
        :key="index"
      >
        <FormTitle :titleText="item.title" />
        <div slot="content" style="margin-top: 30px;">
          <Table
            border
            v-if="!item.isNotTable"
            :columns="item.columns"
            :data="item.data"
          />
          <Input
            v-if="item.isNotTable"
            type="textarea"
            :autosize="{ minRows: 5, maxRows: 5 }"
            v-model="formItem.code1"
          />
        </div>
      </Panel>
      <div class="btnRight" style="margin-top: 30px">
        <Button class="applyBtnRight" @click="showPDF">人才卡片导出pdf</Button>
        <Button type="primary" class="applyBtnRight" @click="returnBack"
          >返回</Button
        >
      </div>
    </Collapse> -->
    <j2-talentCard ref="talentCard"></j2-talentCard>
  </div>
</template>
<script>
import tabPane1Info from "./tabPane1Info.vue";
export default {
  components: {
    tabPane1Info
  },
  data() {
    return {
      value: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      panelList: [
        {
          title: "绩效",
          columns: [
            {
              title: "WHAT评分(2022)",
              key: "applyNo",
              align: "center",
              minWidth: 200
            },
            {
              title: "HOW评分(2022)",
              key: "applyNo",
              align: "center",
              minWidth: 200
            },
            {
              title: "OVERALL评分(2022)",
              key: "applyNo",
              align: "center",
              minWidth: 200
            },
            {
              title: "OVERALL评分(2021)",
              key: "applyNo",
              align: "center",
              minWidth: 200
            },
            {
              title: "OVERALL评分(2020)",
              key: "applyNo",
              align: "center",
              minWidth: 200
            }
          ],
          data: []
        },
        {
          title: "潜能",
          columns: [
            {
              title: "潜能(2022)",
              key: "applyNo",
              align: "center",
              minWidth: 200
            },
            {
              title: "潜能(2021)",
              key: "applyNo",
              align: "center",
              minWidth: 200
            },
            {
              title: "潜能(2020)",
              key: "applyNo",
              align: "center",
              minWidth: 200
            }
          ],
          data: []
        },
        {
          title: "盘点信息",
          columns: [
            {
              title: "放入哪个人才库(职能)",
              key: "applyNo",
              align: "center",
              minWidth: 200
            },
            {
              title: "哪个岗位的继任者",
              key: "applyNo",
              align: "center",
              minWidth: 200
            }
          ],
          data: []
        },
        {
          title: "嘉士伯工作经历",
          columns: [
            {
              title: "开始日期",
              key: "applyNo",
              align: "center",
              minWidth: 200
            },
            {
              title: "业务单元",
              key: "applyNo",
              align: "center",
              minWidth: 200
            },
            {
              title: "部门",
              key: "applyNo",
              align: "center",
              minWidth: 200
            },
            {
              title: "职位",
              key: "applyNo",
              align: "center",
              minWidth: 200
            }
          ],
          data: []
        },
        {
          title: "之前的工作经历",
          columns: [
            {
              title: "开始日期",
              key: "applyNo",
              align: "center",
              minWidth: 200
            },
            {
              title: "结束日期",
              key: "applyNo",
              align: "center",
              minWidth: 200
            },
            {
              title: "前任公司",
              key: "applyNo",
              align: "center",
              minWidth: 200
            },
            {
              title: "职位",
              key: "applyNo",
              align: "center",
              minWidth: 200
            },
            {
              title: "工作描述",
              key: "applyNo",
              align: "center",
              minWidth: 200
            }
          ],
          data: []
        },
        {
          title: "教育背景(最高学历)",
          columns: [
            {
              title: "开始日期",
              key: "applyNo",
              align: "center",
              minWidth: 200
            },
            {
              title: "结束日期",
              key: "applyNo",
              align: "center",
              minWidth: 200
            },
            {
              title: "学校名称",
              key: "applyNo",
              align: "center",
              minWidth: 200
            },
            {
              title: "学历",
              key: "applyNo",
              align: "center",
              minWidth: 200
            },
            {
              title: "专业",
              key: "applyNo",
              align: "center",
              minWidth: 200
            }
          ],
          data: []
        },
        {
          title: "职业理想",
          isNotTable: true
        },
        {
          title: "个人发展计划",
          columns: [
            {
              title: "能力项",
              key: "applyNo",
              align: "center",
              minWidth: 200
            },
            {
              title: "发展目标",
              key: "applyNo",
              align: "center",
              minWidth: 200
            },
            {
              title: "详细描述(10-20-70的行动计划)",
              key: "applyNo",
              align: "center",
              minWidth: 200
            },
            {
              title: "员工自评",
              key: "applyNo",
              align: "center",
              minWidth: 200
            },
            {
              title: "直线经理评估",
              key: "applyNo",
              align: "center",
              minWidth: 200
            }
          ],
          data: []
        }
      ],
      formItem: {}
    };
  },
  methods: {
    showPDF() {
      this.$refs.talentCard.PrintPop = true;
    },
    returnBack() {
      this.$emit("back");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/process/MyQuery/teamInfoComponents/tabPane1Detal.vue